import * as React from "react";
import logo from "../../../files/logos/logo-dbg.png";
import { Link, Typography, WithStyles } from "@material-ui/core";
import { styles } from "./HeaderBar.styles";
import { withStyles } from "@material-ui/core/styles";
import { NavLink } from "react-router-dom";
import { AuthButton } from "../AuthButton/AuthButton";
import { useTranslation } from "react-i18next";
import { useAuthContext } from "../../../auth/AuthProvider";
import { useDispatch, useSelector } from "react-redux";
import * as UserDetailsAction from "../../../stores/user/UserDetailsAction";

export interface IHeaderProps extends WithStyles<typeof styles> {}

const HeaderBarPure: React.FunctionComponent<IHeaderProps> = ({ classes }: IHeaderProps) => {
    const { t } = useTranslation();
    const authContext = useAuthContext();
    const userId = authContext?.user?.id;
    const dispatch = useDispatch();
    const userDetails = useSelector(state => state.userDetails?.currentlyLoggedUser);

    React.useEffect(() => {
        if (userId) {
            dispatch(UserDetailsAction.requestCurrentUser(userId));
        };
    }, [dispatch, userId]);

    return (
        <>
            <div className={classes.root}>
                <div className={classes.logo}>
                    <Link href="/"><img src={logo} alt="Logo" /></Link>
                </div>
                <div className={classes.rightSide}>
                    <ul>
                        {
                            authContext.isAuthenticated
                            ? <li>
                                    <Typography variant="body2">{userDetails?.firstName} {userDetails?.lastName} {userDetails?.username}</Typography>
                                </li>
                            : <li key="register">
                                    <NavLink to="/register" className={classes.link} key="register">
                                        {t("general.register")}
                                    </NavLink>
                                </li>
                        }
                        <li>
                            <AuthButton />
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
};

export const HeaderBar = withStyles(styles)(HeaderBarPure);
